import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { WebApiResponse, PagedResult } from 'src/app/core/api/models/api-model';
import { UserProfileDto, TripMessage, UserProfilesFilterDto } from '../models/chat-models';
import { PublicUserProfileDto } from '../models/profile.models';

@Injectable({
	providedIn: 'root'
})
export class ChatProxyService {

	constructor(private http: HttpClient) { }

	getTwilioToken(): Observable<WebApiResponse<string>> {
		const url = `${environment.api.fasttrackApi}/services/app/Chat/GetTwilioToken`;
		return this.http.get(url);
	}

	createChannel(friendExternalId: string): Observable<WebApiResponse<string>> {
		const url = `${environment.api.fasttrackApi}/services/app/Chat/CreateDirectChatChannel?friendExternalId=${friendExternalId}`;
		return this.http.post(url, null);
	}

	getAvailability(): Observable<WebApiResponse<boolean>> {
		const url = `${environment.api.fasttrackApi}/services/app/Chat/GetAvailability`;
		return this.http.get(url);
	}

	setAvailability(isAvailable: boolean): Observable<WebApiResponse<void>> {
		const url = `${environment.api.fasttrackApi}/services/app/Chat/SetAvailability?isAvailable=${isAvailable}`;
		return this.http.post(url, null);
	}

	getUsersProfilesForMap(lng: number, lat: number, rad: number): Observable<WebApiResponse<UserProfileDto[]>> {
		const url = `${environment.api.fasttrackApi}/services/app/GeoProfiles/GetGeoProfiles?&x=${lng}&y=${lat}&radiusMeters=${rad}`;
		return this.http.get(url);
	}

	getPublicUserProfiles(
		filter: string,
		pageNumber: number,
		pageSize: number,
		isTrekmondo?: boolean,
		county?: string): Observable<WebApiResponse<PagedResult<UserProfileDto>>> {

		const skip = pageNumber * pageSize;

		const queryParams = [
			`maxResultCount=${pageSize}`,
			`skipCount=${skip}`
		];

		if (filter) {
			queryParams.push(`filter=${filter}`);
		}

		if (isTrekmondo) {
			queryParams.push(`isTrekmondo=true`);
		}

		if (county) {
			queryParams.push(`County=${county}`);
		}

		const query = queryParams.join('&');
		const url = `${environment.api.fasttrackApi}/services/app/Profile/GetUserPublicProfiles?${query}`;

		return this.http.get(url);
	}

	getPublicProfilesByFilterCriteria(
		filters: UserProfilesFilterDto): Observable<WebApiResponse<PublicUserProfileDto[]>> {

		const queryParams = [];

		if (filters.filter) {
			queryParams.push(`filter=${filters.filter}`);
		}

		if (filters.isTrekmondo) {
			queryParams.push(`isTrekmondo=true`);
		}

		if (filters.county) {
			queryParams.push(`County=${filters.county}`);
		}

		const query = queryParams.join('&');
		const url = `${environment.api.fasttrackApi}/services/app/Profile/GetPublicProfilesByFilterCriteria?${query}`;
		return this.http.get(url);
	}

	sendTripMessage(tripReferenceNumber: string): Observable<WebApiResponse<any>> {
		const url = `${environment.api.fasttrackApi}/services/app / Chat / SendTripMessageAsync ? tripRefNo = ${tripReferenceNumber} `;
		return this.http.post(url, null);
	}

}
